import {
  GET_ORGANIZERS_ERROR,
  GET_ORGANIZERS_LOCATIONS,
  GET_ORGANIZERS_LOCATIONS_ERROR,
  GET_ORGANIZERS,
  GET_ORGANIZERS_SUCCESS,
  GET_ORGANIZER_INFO,
  GET_ORGANIZER_INFO_SUCCESS,
  GET_ORGANIZER_INFO_FAILURE,
  GET_OWNER_CLUB,
  GET_OWNER_CLUB_SUCCESS,
  GET_TOURNAMENTS,
  GET_TOURNAMENTS_SUCCESS,
  GET_TOURNAMENTS_FAILURE,
  API_ERROR,
  GET_ORGANIZERS_LOCATIONS_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: "",
  organizers: {},
  listLoading: false, listError: "", locationsLoading: false, locationsError: "",
  organizerInfo: {},
  organizerClubInfo: {},
  organizersLocations: [],
  tournaments: {},
  loading: false,
  profileLoading: false,
  // The profile being opened, and why its read failed ({ status }); a late answer for another organizer is dropped.
  activeOrganizerId: null,
  profileError: null,
  tournamentsLoading: false,
  tournamentsError: false,
}

const organizers = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORGANIZERS_ERROR:
      return { ...state, listLoading: false, listError: "Could not load organizers. Please try again." }
    case GET_ORGANIZERS_LOCATIONS:
      return { ...state, locationsLoading: true, locationsError: "" }
    case GET_ORGANIZERS_LOCATIONS_ERROR:
      return { ...state, locationsLoading: false, locationsError: "Could not load locations." }
    case GET_ORGANIZERS_LOCATIONS_SUCCESS:
      state = {
        ...state,
        organizersLocations: action?.payload,
        locationsLoading: false, locationsError: "",
      }
      break
    case GET_ORGANIZERS:
      state = {
        ...state, listLoading: true, listError: "",
        loading: true,
      }
      break
    case GET_ORGANIZERS_SUCCESS:
      state = {
        ...state,
        loading: false,
        organizers: action.payload,
        listLoading: false, listError: "",
      }
      break
    case GET_ORGANIZER_INFO:
      state = {
        ...state,
        loading: true,
        profileLoading: true,
        activeOrganizerId: action.id,
        profileError: null,
        organizerInfo: {},
        organizerClubInfo: {},
        tournaments: {},
      }
      break
    case GET_ORGANIZER_INFO_SUCCESS:
      if (action.profileId && action.profileId !== state.activeOrganizerId) break
      state = {
        ...state,
        loading: false,
        profileLoading: false,
        profileError: null,
        organizerInfo: action.payload,
      }
      break
    case GET_ORGANIZER_INFO_FAILURE:
      if (action.profileId !== state.activeOrganizerId) break
      state = {
        ...state,
        loading: false,
        profileLoading: false,
        profileError: action.payload,
        organizerInfo: {},
      }
      break
    case GET_OWNER_CLUB:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_OWNER_CLUB_SUCCESS:
      state = {
        ...state,
        loading: false,
        organizerClubInfo: action.payload,
      }
      break
    case GET_TOURNAMENTS:
      state = {
        ...state,
        tournamentsLoading: true,
        tournamentsError: false,
      }
      break
    // The tournaments of the organizer being opened: a late answer for another organizer is dropped.
    case GET_TOURNAMENTS_SUCCESS:
      if (action.profileId && action.profileId !== state.activeOrganizerId) break
      state = {
        ...state,
        tournamentsLoading: false,
        tournamentsError: false,
        tournaments: action.payload,
      }
      break
    case GET_TOURNAMENTS_FAILURE:
      if (action.profileId && action.profileId !== state.activeOrganizerId) break
      state = {
        ...state,
        tournamentsLoading: false,
        tournamentsError: true,
      }
      break
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        profileLoading: false,
        tournamentsLoading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default organizers
